import {
    Button,
    FormControl,
    FormLabel,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Stack,
    Text,
    Textarea,
} from "@chakra-ui/react";
import React, {useState} from "react";

// Block or unblock a user. The same backend endpoint toggles the status, so the
// dialog only swaps its copy/colour based on the user's current state. The
// parent's `handleBlockUser(userId, remarks)` performs the call and owns toasts.
function UserBlockDialog({isOpen, onClose, user, handleBlockUser}) {
    const [remarks, setRemarks] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);

    const isBlocked = user?.status === "B";
    const actionLabel = isBlocked ? "Unblock" : "Block";

    const handleSubmit = async () => {
        setIsSubmitting(true);
        try {
            await handleBlockUser(user?.id, remarks.trim());
            setRemarks("");
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleClose = () => {
        if (isSubmitting) return;
        setRemarks("");
        onClose();
    };

    return (
        <Modal isOpen={isOpen} onClose={handleClose} size="md" isCentered>
            <ModalOverlay/>
            <ModalContent>
                <ModalHeader>{actionLabel} User</ModalHeader>
                <ModalCloseButton/>
                <ModalBody>
                    <Stack spacing={4}>
                        <Text fontSize="sm" color="gray.500">
                            {isBlocked
                                ? "This restores access for "
                                : "This prevents "}
                            <Text as="span" fontWeight="600">
                                {user?.fullName || "this user"}
                            </Text>
                            {isBlocked ? "." : " from signing in until unblocked."}
                        </Text>
                        <FormControl isRequired={!isBlocked}>
                            <FormLabel>Remarks{isBlocked ? " (optional)" : ""}</FormLabel>
                            <Textarea
                                value={remarks}
                                onChange={(e) => setRemarks(e.target.value)}
                                placeholder={`Reason for ${actionLabel.toLowerCase()}ing the user`}
                            />
                        </FormControl>
                    </Stack>
                </ModalBody>
                <ModalFooter>
                    <Button variant="ghost" onClick={handleClose} isDisabled={isSubmitting}>
                        Cancel
                    </Button>
                    <Button
                        colorScheme={isBlocked ? "green" : "red"}
                        ml={3}
                        onClick={handleSubmit}
                        isLoading={isSubmitting}
                        isDisabled={!isBlocked && !remarks.trim()}
                    >
                        {actionLabel}
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}

export default UserBlockDialog;
